export default __webpack_public_path__ + "static/media/nomina2024.9ece0451.pdf";